// src/pages/SupplierManagement.jsx
import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { PlusCircle, ArrowLeft } from 'lucide-react';
import SupplierList from '../components/partners/SupplierList';
import SupplierForm from '../components/partners/SupplierForm';
import SupplierDetails from '../components/partners/SupplierDetails';
import useAuth from '../hooks/useAuth';

const SupplierManagement = () => {
    const { isAdmin, isManager } = useAuth();
    const [view, setView] = useState('list');
    const [selectedSupplierId, setSelectedSupplierId] = useState(null);

    const canModify = isAdmin || isManager;

    const handleAddSupplier = () => {
        setSelectedSupplierId(null);
        setView('form');
    };

    const handleEditSupplier = (supplierId) => {
        setSelectedSupplierId(supplierId);
        setView('form');
    };

    const handleViewSupplier = (supplierId) => {
        setSelectedSupplierId(supplierId);
        setView('details');
    };

    const handleCancel = () => {
        setView('list');
        setSelectedSupplierId(null);
    };

    const handleSuccess = () => {
        setView('list');
        setSelectedSupplierId(null);
    };

    return (
        <Container fluid>
            <div className="d-flex justify-content-between align-items-center mb-4">
                {view === 'list' ? (
                    <h1 className="h3">Gestion des Clients</h1>
                ) : (
                    <div className="d-flex align-items-center">
                        <Button
                            variant="link"
                            className="p-0 me-2"
                            onClick={handleCancel}
                        >
                            <ArrowLeft size={20} />
                        </Button>
                        <h1 className="h3 mb-0">
                            {view === 'form'
                                ? (selectedSupplierId ? 'Modifier un client' : 'Ajouter un client')
                                : 'Détails du client'
                            }
                        </h1>
                    </div>
                )}

                {canModify && view === 'list' && (
                    <Button
                        variant="primary"
                        onClick={handleAddSupplier}
                    >
                        <PlusCircle size={16} className="me-1" />
                        Nouveau client
                    </Button>
                )}
            </div>

            {view === 'list' && (
                <SupplierList
                    onAddSupplier={handleAddSupplier}
                    onEditSupplier={handleEditSupplier}
                    onViewSupplier={handleViewSupplier}
                />
            )}

            {view === 'form' && (
                <SupplierForm
                    supplierId={selectedSupplierId}
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}

            {view === 'details' && (
                <SupplierDetails
                    supplierId={selectedSupplierId}
                    onEdit={handleEditSupplier}
                    onBack={handleCancel}
                />
            )}
        </Container>
    );
};

export default SupplierManagement;